import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const Step9Shared = () => (
  <ol>
    <li>
      <FormattedMessage {...messages.other1} />
    </li>
    <li>
      <FormattedMessage {...messages.other2} />
    </li>
    <li>
      <FormattedMessage {...messages.other3} />
    </li>
    <li>
      <FormattedMessage {...messages.other4} />
    </li>
    <li>
      <FormattedMessage {...messages.other5} />
    </li>
  </ol>
);

export default Step9Shared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step9/Step9Shared.js